import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { withStyles, Grid } from '@material-ui/core';
import Translator from 'translator';
import { UserCard, FHEContainerScroll, FHEContainer, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { ApplianceIconComponent, SvgSDM17DEC } from 'data/common/iconsvg';
import DetailExpansionPanelRow from './ProductModule/DetailExpansionPanelRow';
import DetailExpansionPanel from './ProductModule/DetailExpansionPanel';

import {
    getSDM17DECDetails,
    refreshSDM17DECStatus,
    switchSDM17DECMaster,
    dissociateSDM17DECUser,
    dissociateSDM17DECUserAndSwitchMaster
} from '../../data/SDM17DEC/actions';

class SDM17DECDetail extends PureComponent {
    static propTypes = {
        getSDM17DECDetails: PropTypes.func.isRequired,
        dissociateSDM17DECUser: PropTypes.func.isRequired,
        dissociateSDM17DECUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSDM17DECMaster: PropTypes.func.isRequired,
        refreshSDM17DECStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        SDM17DEC: PropTypes.object,
        filteredProductModules: PropTypes.object,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        SDM17DEC: new Map(),
        filteredProductModules: null
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false,
            expanded: null
        };
    }

    componentDidMount() {
        this.getSDM17DECDetails();
    }

    getSDM17DECDetails = () => {
        const { getSDM17DECDetails, match } = this.props;
        this.setState({ loading: true, error: null });
        getSDM17DECDetails(match.params.SDM17DECId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSDM17DECMaster = (SDM17DECMac, userId) => {
        const { switchSDM17DECMaster } = this.props;

        return switchSDM17DECMaster(SDM17DECMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM17DECUser = (SDM17DECMac, userId) => {
        const { dissociateSDM17DECUser } = this.props;

        return dissociateSDM17DECUser(SDM17DECMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM17DECUserAndSwitchMaster = (SDM17DECMac, userId, masterId) => {
        const { dissociateSDM17DECUserAndSwitchMaster } = this.props;

        return dissociateSDM17DECUserAndSwitchMaster(SDM17DECMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    refreshStateSDM17DEC = () => {
        const { refreshSDM17DECStatus, match } = this.props;
        return refreshSDM17DECStatus(match.params.SDM17DECId)
            .then(() => {
                Toastr.success(Translator.translate('general.products.SDM17DEC.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('general.products.SDM17DEC.table.action.refresh.error')
                );
                throw err;
            });
    };

    handleChange = panel => {
        const { expanded } = this.state;
        if (expanded === panel) {
            this.setState({
                expanded: null
            });
        } else {
            this.setState({
                expanded: panel
            });
        }
    };

    productModulesRender = lines => {
        const { expanded } = this.state;
        let data = [];

        lines.forEach((line, key) => {
            data.push(
                <DetailExpansionPanelRow
                    key={key}
                    moduleKey={key}
                    expanded={expanded}
                    handleChange={this.handleChange.bind(this, key)}
                    line={line}
                    lineType={line.get('type')}
                    lineLabel={line.get('label')}
                />
            );
        });
        return data;
    };

    productModuleCategoriesRender() {
        const { filteredProductModules, theme } = this.props;
        let data = [];
        if (filteredProductModules) {
            filteredProductModules.forEach((lines, key) => {
                data.push(
                    <DetailExpansionPanel
                        key={key}
                        headerTitle={Translator.translate(`general.productModules.${key}`)}
                        headerSvg={
                            <ApplianceIconComponent
                                productType="fhe_product"
                                moduleType={lines.get('type')}
                                productLineType={key}
                                size={40}
                                color={theme.palette.common.white}
                                secondaryColor={theme.palette.primary.main}
                            />
                        }
                    >
                        {this.productModulesRender(lines)}
                    </DetailExpansionPanel>
                );
            });
        }

        return data;
    }

    userList() {
        const { usersLoading, actionDisabled } = this.state;
        const { SDM17DEC, profile } = this.props;
        const users = [];

        if (!usersLoading && SDM17DEC.has('otherUsers')) {
            SDM17DEC.get('otherUsers').map(user => {
                const isMaster = SDM17DEC.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    SDM17DEC.get('otherUsers').map(user => {
                        if (user.get('_id') !== SDM17DEC.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={SDM17DEC}
                            productName="SDM17DEC"
                            environment="fhepool"
                            dissociateUserFunc={this.dissociateSDM17DECUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSDM17DECUserAndSwitchMaster}
                            switchMasterFunc={this.switchSDM17DECMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }

    renderChildren = () => {
        const { SDM17DEC, classes } = this.props;
        return (
            <Fragment>
                <FHETitle title={SDM17DEC.get('label')} Icon={SvgSDM17DEC} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        SDM17DEC.get('macAddress')
                                            ? SDM17DEC.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={SDM17DEC.get('firmwareVersion')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.products.SDM17DEC.table.action.refresh.tooltip')}
                                    onClick={this.refreshStateSDM17DEC}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${SDM17DEC.get('state')}`)}
                                    classContent={SDM17DEC.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.addressIp')}
                                    itemContent={SDM17DEC.get('addressIp')}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>

                    <FHEDivider title={Translator.translate('general.Users')} />
                    {this.userList()}

                    <FHEDivider title={Translator.translate('general.productModules.title')} />
                    {this.productModuleCategoriesRender()}
                </FHEContainerScroll>
            </Fragment>
        );
    };
    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;

        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSDM17DECDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function productModulesFilter(productModules) {
    let filteredProductModules = new Map();
    productModules.map((productModule, productModuleKey) => {
        filteredProductModules = filteredProductModules.mergeIn([productModule.get('type'), productModuleKey], productModule);
    });
    return filteredProductModules;
}

function mapStateToProps(state, props) {
    const users = state.environments.fhepool.data.Users.get('list');
    let SDM17DEC = state.environments.fhepool.data.SDM17DEC.getIn(['list', props.match.params.SDM17DECId], new Map());
    const productModules = SDM17DEC.getIn(['lines'], new Map());

    if (SDM17DEC.get('usersList')) {
        let otherUsers = [];
        let masterUser = new Map();
        SDM17DEC.get('usersList').forEach(userId => {
            users.find(user => {
                if (userId === user.get('_id')) {
                    if (masterUser.size === 0 && SDM17DEC.get('userMasterId') === user.get('_id')) {
                        masterUser = user;
                        otherUsers.unshift(user);
                    } else {
                        otherUsers.push(user);
                    }
                }
            });
        });
        SDM17DEC = SDM17DEC.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
    }

    return {
        profile: state.data.user,
        SDM17DEC,
        initialized: state.environments.fhepool.data.SDM17DEC.get('initialized'),
        filteredProductModules: productModulesFilter(productModules)
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                { getSDM17DECDetails, refreshSDM17DECStatus, switchSDM17DECMaster, dissociateSDM17DECUser, dissociateSDM17DECUserAndSwitchMaster },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(SDM17DECDetail))
);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/details.js